import { Box, useTheme } from "@mui/material";
import DOMPurify from "dompurify";
import { ARTICLE_HTML_ALLOWED_TAGS } from "@/constants/article-html";

export function ArticleContent({ html }: { html: string }) {
  const theme = useTheme();
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...ARTICLE_HTML_ALLOWED_TAGS],
    ALLOWED_ATTR: [],
  });

  return (
    <Box
      sx={{
        "& p": {
          mb: 2,
          lineHeight: 1.8,
          fontSize: "1.05rem",
          color: theme.palette.text.primary,
        },
        "& h2": {
          fontFamily: '"Playfair Display", serif',
          mt: 3,
          mb: 1.5,
          fontSize: "1.5rem",
          color: theme.palette.text.primary,
        },
        "& h3": {
          fontFamily: '"Playfair Display", serif',
          mt: 2.5,
          mb: 1,
          fontSize: "1.25rem",
          color: theme.palette.text.primary,
        },
        "& ul, & ol": {
          pl: 3,
          mb: 2,
          color: theme.palette.text.primary,
        },
        "& li": {
          mb: 0.5,
          lineHeight: 1.7,
        },
        "& strong": { fontWeight: 600 },
        "& em": { fontStyle: "italic" },
      }}
      dangerouslySetInnerHTML={{ __html: clean }}
    />
  );
}
